// Global Header Transparency Script
// Makes header transparent on pages/about?view=new-custom-page and white on scroll

(function() {
  'use strict';
  
  // Configuration
  const TARGET_PATH = '/pages/about';
  const TARGET_PARAM = 'view';
  const TARGET_VALUE = 'new-custom-page';
  const HEADER_SELECTOR = '#shopify-section-header';
  const SCROLL_THRESHOLD = 50; // pixels scrolled before changing background
  
  // Check if current page matches the target URL
  function isTargetPage() {
    const currentPath = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);
    const viewParam = urlParams.get(TARGET_PARAM);
    
    return currentPath.includes(TARGET_PATH) && viewParam === TARGET_VALUE;
  }
  
  // Get header element
  function getHeader() {
    return document.querySelector(HEADER_SELECTOR);
  }
  
  // Apply transparent styles
  function makeHeaderTransparent(header) {
    header.style.backgroundColor = 'transparent';
    header.style.transition = 'background-color 0.3s ease';
    header.classList.add('header-transparent');
  }
  
  // Apply white background
  function makeHeaderWhite(header) {
    header.style.backgroundColor = '#fff';
    header.classList.remove('header-transparent');
    header.classList.add('header-scrolled');
  }
  
  // Handle scroll event
  function handleScroll() {
    const header = getHeader();
    if (!header) return;
    
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollPosition > SCROLL_THRESHOLD) {
      makeHeaderWhite(header);
    } else {
      makeHeaderTransparent(header);
    }
  }
  
  // Initialize the script
  function init() {
    // Only run on target page
    if (!isTargetPage()) {
      return;
    }
    
    const header = getHeader();
    if (!header) {
      console.warn('Header element not found:', HEADER_SELECTOR);
      return;
    }
    
    // Set initial transparent state
    makeHeaderTransparent(header);
    
    // Add scroll listener
    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
    
    // Check initial scroll position
    handleScroll();
  }
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();